import React from 'react';
import {
    Router,
    Switch,
    Route,
} from 'react-router-dom';
import {
    ToastContainer,
} from 'react-toastify';
// import {
//     Button,
// } from 'antd';

// Pages
import LoginPage from './public/login.page';
import HomePage from './app/home.page';
import HistoryPage from './app/history.page';
import CompletedPage from './app/completed.page';
import SuccessPage from './app/success.page';
// Helpers
import history from '../history';

const Pages = () => {
    return (
        <div className="main-content-wrapper">
        <ToastContainer
            closeButton={false}
            autoClose={3000}
        />
        <Router history={history}>
            <Switch>
                <Route path="/" exact component={LoginPage}/>
                <Route path="/home" exact component={HomePage}/>
                <Route path="/history" exact component={HistoryPage}/>
                <Route path="/success" exact component={SuccessPage}/>
                <Route path="/completed" exact component={CompletedPage}/>
            </Switch>
        </Router>
        </div>
    );
};

export default Pages;
